import React from 'react';
import { Slide, Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import './HomePageSlider.css'

const HomePageSlider = () => {
    const images = [
        "/images/projects/VPR03286_Vasso_Paraschi.webp",
        "/images/projects/VPR02630_Vasso_Paraschi.webp",
        "/images/projects/VPR02493_Vasso_Paraschi.webp",
        "/images/projects/VPR02639_Vasso_Paraschi.webp",
        "/images/projects/VPR02364_Vasso_Paraschi_copy.webp",
        "/images/projects/VPR02331_Vasso_Paraschi.webp",
        "/images/projects/VPR02723_Vasso_Paraschi.webp",
        "/images/projects/VPR02466_Vasso_Paraschi.webp",
    ];

    return (
        <Fade
        arrows={false}
        duration={4000}
        pauseOnHover={false}
        >
            <div className="each-slide-effect">
                <div style={{ 'backgroundImage': `url(${images[0]})` }}>
                </div>
            </div>
            <div className="each-slide-effect">
                <div style={{ 'backgroundImage': `url(${images[1]})` }}>
                </div>
            </div>
            <div className="each-slide-effect">
                <div style={{ 'backgroundImage': `url(${images[2]})` }}>
                </div>
            </div>
            <div className="each-slide-effect">
                <div style={{ 'backgroundImage': `url(${images[3]})` }}>
                </div>
            </div>
            <div className="each-slide-effect">
                <div style={{ 'backgroundImage': `url(${images[4]})` }}>
                </div>
            </div>
            <div className="each-slide-effect">
                <div style={{ 'backgroundImage': `url(${images[5]})` }}>
                </div>
            </div>
            <div className="each-slide-effect">
                <div style={{ 'backgroundImage': `url(${images[6]})` }}>
                </div>
            </div>
            <div className="each-slide-effect">
                <div style={{ 'backgroundImage': `url(${images[7]})` }}>
                </div>
            </div>
        </Fade>
    );
};

export default HomePageSlider;
